export default "__VITE_ASSET__DmJvo9nx__"